// extracted by mini-css-extract-plugin
export var editButton = "detailsEvent-module--edit-button--12aa1";
export var eventContentFooter = "detailsEvent-module--event-content-footer--92dbd";
export var eventContentFooterBack = "detailsEvent-module--event-content-footer-back--30925";
export var eventImg = "detailsEvent-module--event-img--d5656";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--fd4a5";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--ab59b";
export var eventTitle = "detailsEvent-module--event-title--84528";
export var gridAriane = "detailsEvent-module--grid-ariane--9130d";
export var gridContent = "detailsEvent-module--grid-content--1e555";
export var gridDate = "detailsEvent-module--grid-date--7549c";
export var gridPlace = "detailsEvent-module--grid-place--852aa";
export var gridResume = "detailsEvent-module--grid-resume--775e0";
export var gridTags = "detailsEvent-module--grid-tags--1fe77";
export var gridTitle = "detailsEvent-module--grid-title--c6e63";
export var pageEvent = "detailsEvent-module--page-event--c768f";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--f7758";